<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 7C12 7 10.5 11.5 6 11.5C1.5 11.5 0 7 0 7C0 7 1.5 2.5 6 2.5C10.5 2.5 12 7 12 7ZM9 7C9 8.65685 7.65685 10 6 10C4.34315 10 3 8.65685 3 7C3 5.34315 4.34315 4 6 4C7.65685 4 9 5.34315 9 7ZM6 8.5C6.82843 8.5 7.5 7.82843 7.5 7C7.5 6.17157 6.82843 5.5 6 5.5C5.17157 5.5 4.5 6.17157 4.5 7C4.5 7.82843 5.17157 8.5 6 8.5Z"
    fill="currentColor"
  />
</template>
